import { render, staticRenderFns } from "./CodeEditorComponent.vue?vue&type=template&id=5de94948&scoped=true&"
import script from "./CodeEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./CodeEditorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CodeEditorComponent.vue?vue&type=style&index=0&id=5de94948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de94948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VLabel,VMessages})
